import React from "react";

const TOAST_ICONS = {
  success: "check_circle",
  error: "error",
  warning: "warning",
  info: "info",
};

function InventoryToast({ type = "info", message, onClose }) {
  if (!message) return null;

  return (
    <div
      className={`inventory-toast is-${type}`}
      role={type === "error" || type === "warning" ? "alert" : "status"}
      aria-live={type === "error" || type === "warning" ? "assertive" : "polite"}
    >
      <span className="inventory-toast__icon material-symbols-outlined" aria-hidden="true">
        {TOAST_ICONS[type] || TOAST_ICONS.info}
      </span>
      <p>{message}</p>
      {onClose ? (
        <button type="button" aria-label="Cerrar notificación" onClick={onClose}>
          <span className="material-symbols-outlined" aria-hidden="true">close</span>
        </button>
      ) : null}
    </div>
  );
}

export default InventoryToast;
